import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const AchOnFile = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/AchOnFile/AchOnFile')
);
const NotFound = withLazyFallback(() => import('components/NotFound'));
const PatientAccount = withLazyFallback(() => import('components/practice/charts/Account/Account'));
const CConFile = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/CConFile/CConFileTable')
);
const PurchasedPackages = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/PurchasedPackages/PurchasedPackages')
);
const Quotes = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/Quotes/Quotes')
);
const PracticePatientSettings = withLazyFallback(
  () => import('components/practice/charts/PracticePatientSettings')
);

const PRACTICE_CHARTS_ACCOUNT = [
  {
    path: 'account',
    element: <PatientAccount />,
    handle: { title: 'Account' },
    children: [
      { path: '', element: <PurchasedPackages />, handle: { title: 'Purchased Packages' } },
      {
        path: 'purchased-packages',
        element: <PurchasedPackages />,
        handle: { title: 'Purchased Packages' }
      },
      { path: 'quotes', element: <Quotes />, handle: { title: 'Quotes' } },
      { path: 'settings', element: <PracticePatientSettings />, handle: { title: 'Settings' } },
      { path: 'cards', element: <CConFile />, handle: { title: 'CC on File' } },
      { path: 'ach', element: <AchOnFile />, handle: { title: 'ACH on File' } },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_CHARTS_ACCOUNT;
